import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';
import { useAuth } from '../../../contexts/AuthContext';

/** Lightweight check for CRM menu link (RLS: own row only). */
export function useHasPartnerRecord(): boolean {
  const { user } = useAuth();
  const [hasPartner, setHasPartner] = useState(false);

  const load = useCallback(async () => {
    if (!user?.id) {
      setHasPartner(false);
      return;
    }
    const { data, error } = await supabase
      .from('partners')
      .select('id')
      .eq('user_id', user.id)
      .maybeSingle();

    if (error) {
      setHasPartner(false);
      return;
    }
    setHasPartner(Boolean(data?.id));
  }, [user?.id]);

  useEffect(() => {
    void load();
  }, [load]);

  return hasPartner;
}
